exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".profile-modal{left:50vw!important;top:50vh!important}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/views/Main.vue"],"names":[],"mappings":"AACA,eACI,oBAAsB,AACtB,kBAAqB,CACxB","file":"Main.vue","sourcesContent":["\n.profile-modal {\n    left: 50vw !important;\n    top: 50vh !important;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-52991fa2","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/Main.vue
// module id = 1886
// module chunks = 8